// import { initializeApp } from "firebase/app";
// import { getAuth } from "firebase/auth";
// import { getFirestore } from "firebase/firestore";

// const firebaseConfig = {
//     apiKey: "AIzaSyCUbJtkZUOSIoVrZT5ejo1dku3ekjW7oXo",
//     authDomain: "truck-tuck.firebaseapp.com",
//     projectId: "truck-tuck",
//     storageBucket: "truck-tuck.firebasestorage.app",
//     messagingSenderId: "1090877167795",
//     appId: "1:1090877167795:web:38b12ecf8e00c04dec38c6",
//     measurementId: "G-79RK7GE8G5"
// };

// export const app = initializeApp(firebaseConfig);
// export const auth = getAuth();
// export const db = getFirestore();

//---------------------------------------------------------testing account----------------------------------------------------
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
    apiKey: "AIzaSyDW9uiVBBejF_J1ICHfyCqzEovMyBcoUHg",
    authDomain: "truck-tuck-4f2d8.firebaseapp.com",
    projectId: "truck-tuck-4f2d8",
    storageBucket: "truck-tuck-4f2d8.firebasestorage.app",
    messagingSenderId: "1047979091766",
    appId: "1:1047979091766:web:fc92d713c7d0f91840f597",
    measurementId: "G-NL3T1SGTHB"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore();
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider("apple.com");
appleProvider.addScope("email");
appleProvider.addScope("name");